import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ProgramVersionItemDto } from '../../api/types/dtos/program';
import styles from './SearchCriteriaModal.module.scss';

interface SearchCriteriaModalProps {
  open: boolean;
  onClose: () => void;
  onAdd: (selectedItems: ProgramVersionItemDto[]) => void;
  organizationId: string;
  programId: string;
  versionId: string;
  existingItems: ProgramVersionItemDto[];
}

export const SearchCriteriaModal: React.FC<SearchCriteriaModalProps> = ({
  open,
  onClose,
  onAdd,
  existingItems
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItems, setSelectedItems] = useState<ProgramVersionItemDto[]>([]);

  const handleSearch = (value: string) => {
    setSearchTerm(value.toLowerCase());
  };

  const handleToggleItem = (item: ProgramVersionItemDto) => {
    setSelectedItems(prev => {
      const isSelected = prev.some(i => i.id === item.id);
      if (isSelected) {
        return prev.filter(i => i.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
  };

  const handleAdd = () => {
    onAdd(selectedItems);
    setSelectedItems([]);
    onClose();
  };

  const filteredItems = existingItems.filter(item => {
    const searchString = searchTerm.toLowerCase();
    return (
      (item.name?.toLowerCase() || '').includes(searchString) ||
      (item.description?.toLowerCase() || '').includes(searchString) ||
      (item.cpNumber?.toLowerCase() || '').includes(searchString)
    );
  });

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Buscar Criterios</DialogTitle>
      <DialogContent>
        <div className={styles.searchContainer}>
          <TextField
            fullWidth
            placeholder="Buscar por número, nombre o descripción..."
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            variant="outlined"
            size="small"
          />
        </div>

        <div className={styles.itemsList}>
          {filteredItems.map(item => (
            <FormControlLabel
              key={item.id}
              control={
                <Checkbox
                  checked={selectedItems.some(i => i.id === item.id)}
                  onChange={() => handleToggleItem(item)}
                />
              }
              label={
                <div className={styles.itemLabel}>
                  <strong className={styles.cpNumber}>{item.cpNumber}:</strong>
                  <span className={styles.name}>{item.name}</span>
                </div>
              }
            />
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button 
          onClick={handleAdd}
          variant="contained"
          color="primary"
          disabled={selectedItems.length === 0}
        >
          Agregar ({selectedItems.length})
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SearchCriteriaModal; 